import React from 'react';

const LoadingSpinner = ({ 
  size = 'md', 
  color = 'teal', 
  text = null, 
  fullScreen = false,
  className='' 
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16'
  };

  const colorClasses = {
    teal: 'border-teal-500',
    blue: 'border-blue-500',
    green: 'border-green-500',
    red: 'border-red-500',
    yellow: 'border-yellow-500',
    gray: 'border-gray-500'
  };

  const spinnerElement = (
    <div 
      className={`animate-spin rounded-full border-b-2 ${sizeClasses[size]} ${colorClasses[color]}`}
      role="status"
      aria-label="Loading"
    ></div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-gray-800 rounded-lg p-8 flex flex-col items-center">
          {spinnerElement}
          {text && <p className="mt-4 text-gray-300 dark:text-gray-600">{text}</p>}
        </div>
      </div>
    );
  }

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div className="flex flex-col items-center">
        {spinnerElement}
        {text && <p className="mt-2 text-gray-300 text-sm dark:text-gray-600">{text}</p>}
      </div>
    </div>
  );
};

export default LoadingSpinner;
